var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

import { SiteHeaderLayout } from "../components/entities/site-header-layout";
import { SiteHeaderContext, SiteHeaderDefaultState } from "../components/context/site-header-context";
import { useSite } from "./use-site";
import * as React from 'react';
import { usePatchableState } from "./use-patchable-state";
import { useClickOutside } from "./use-click-outside";
import { includes, map } from "lodash";
import { isDarkColor } from "../utils/is-dark-color";
import { useThemeColor } from "./use-theme-color";
import { useComponentColor } from "./use-component-color";
import { classNames } from "../utils/cn";
import { PersonCircleIcon } from "../components/elements/person-circle-icon";
import { useMainMenu } from "./use-main-menu";
import { useInView } from "react-intersection-observer";
var cls = classNames('site-header-layout');
import { trim } from 'lodash';
import { useActiveEntity } from "./use-active-entity";
import { useIcons } from "./use-icons";
export var useSiteHeader = function useSiteHeader() {
  var e_1, _a;

  var _b, _c, _d, _e;

  var site = useSite();
  var menu = useMainMenu();
  var currentEntity = useActiveEntity();
  var Icons = useIcons();

  var _f = useSite(),
      loginLabel = _f.loginLabel,
      platformUrl = _f.platformUrl;

  var icons = useIcons();
  var context = React.useContext(SiteHeaderContext);

  var defaultState = __assign(__assign({}, SiteHeaderDefaultState), context.defaultState || {});

  var component = context.component,
      _g = context.variant,
      variant = _g === void 0 ? 'overlay' : _g,
      activeColor = context.activeColor,
      hoverColor = context.hoverColor;
  var showLogin = context.showLogin || site.showLogin || process.env.SHOW_LOGIN === 'true';
  var showSearch = context.showSearch || process.env.SHOW_SEARCH === 'true';
  var showShare = context.showShare || site.showShareMenu || process.env.SHOW_SHARE === 'true';
  var showContactUs = context.showContactUs || site.showContactUs || process.env.SHOW_CONTACT_US === 'true';
  var isInverted = includes(['overlay', 'dark'], variant) || !!(context.backgroundColor && isDarkColor(context.backgroundColor));
  var themeBackgroundColor = useThemeColor.apply(void 0, __spreadArray([], __read(isInverted ? ['dark-background', 'dark'] : ['light-background', 'light']), false));
  var backgroundColor = context.backgroundColor || themeBackgroundColor;
  var color = context.color || (isInverted ? 'light' : 'dark');
  var tuple = React.useState(defaultState);

  var _h = __read(usePatchableState(tuple), 3),
      state = _h[0],
      setState = _h[1],
      patchState = _h[2];

  var isLangMenuVisible = state.isLangMenuVisible,
      isShareMenuVisible = state.isShareMenuVisible,
      isNavigationMenuVisible = state.isNavigationMenuVisible,
      isPinnedNavigationMenuVisible = state.isPinnedNavigationMenuVisible,
      isContactUsMenuVisible = state.isContactUsMenuVisible,
      disclosedMenuItem = state.disclosedMenuItem,
      isMenuBarVisible = state.isMenuBarVisible;

  var toggleLangMenu = function toggleLangMenu() {
    return patchState({
      isLangMenuVisible: !isLangMenuVisible
    });
  };

  var toggleShareMenu = function toggleShareMenu() {
    return patchState({
      isShareMenuVisible: !isShareMenuVisible
    });
  };

  var toggleNavigationMenu = function toggleNavigationMenu() {
    return patchState({
      isNavigationMenuVisible: !isNavigationMenuVisible
    });
  };

  var togglePinnedNavigationMenu = function togglePinnedNavigationMenu() {
    return patchState({
      isPinnedNavigationMenuVisible: !isPinnedNavigationMenuVisible
    });
  };

  var toggleContactUsMenu = function toggleContactUsMenu() {
    return patchState({
      isContactUsMenuVisible: !isContactUsMenuVisible
    });
  };

  var hideLangMenu = function hideLangMenu() {
    return patchState({
      isLangMenuVisible: false
    });
  };

  var hideShareMenu = function hideShareMenu() {
    return patchState({
      isShareMenuVisible: false
    });
  };

  var hideNavigationMenu = function hideNavigationMenu() {
    return patchState({
      isNavigationMenuVisible: false
    });
  };

  var hidePinnedNavigationMenu = function hidePinnedNavigationMenu() {
    return patchState({
      isPinnedNavigationMenuVisible: false
    });
  };

  var hideContactUsMenu = function hideContactUsMenu() {
    return patchState({
      isContactUsMenuVisible: false
    });
  };

  var setDisclosedMenuItem = function setDisclosedMenuItem(disclosedMenuItem) {
    return patchState({
      disclosedMenuItem: disclosedMenuItem
    });
  };

  var hideDisclosedMenuItem = function hideDisclosedMenuItem() {
    return patchState({
      disclosedMenuItem: ''
    });
  };

  var showLangMenu = function showLangMenu() {
    return patchState({
      isLangMenuVisible: true
    });
  };

  var showShareMenu = function showShareMenu() {
    return patchState({
      isShareMenuVisible: true
    });
  };

  var showNavigationMenu = function showNavigationMenu() {
    return patchState({
      isNavigationMenuVisible: true
    });
  };

  var showPinnedNavigationMenu = function showPinnedNavigationMenu() {
    return patchState({
      isPinnedNavigationMenuVisible: true
    });
  };

  var showContactUsMenu = function showContactUsMenu() {
    return patchState({
      isContactUsMenuVisible: true
    });
  };

  var langMenuRef = useClickOutside(function (e) {
    if (isLangMenuVisible) {
      hideLangMenu();
    }
  }, [isLangMenuVisible]);
  var langMenuRevealRef = useClickOutside(function (e) {
    if (isLangMenuVisible) {
      hideLangMenu();
    }
  }, [isLangMenuVisible]);
  var shareMenuRevealRef = useClickOutside(function (e) {
    if (isShareMenuVisible) {
      hideShareMenu();
    }
  }, [isShareMenuVisible]);
  var shareMenuRef = useClickOutside(function (e) {
    if (isShareMenuVisible) {
      hideShareMenu();
    }
  }, [isShareMenuVisible]);
  var pinnedNavigationMenuRef = useClickOutside(function (e) {
    if (isPinnedNavigationMenuVisible) {
      hidePinnedNavigationMenu();
    }
  }, [isPinnedNavigationMenuVisible]);
  var navigationMenuRef = useClickOutside(function (e) {
    if (isNavigationMenuVisible) {
      hideNavigationMenu();
    }
  }, [isNavigationMenuVisible]);
  var navigationDisclosedItemRef = useClickOutside(function (e) {
    if (disclosedMenuItem) {
      hideDisclosedMenuItem();
    }
  }, [disclosedMenuItem]);

  var _j = useInView({
    delay: 200
  }),
      ref = _j.ref,
      inView = _j.inView;

  React.useLayoutEffect(function () {
    var scrollY = 0;

    if (typeof window !== 'undefined') {
      scrollY = window.scrollY;
    }

    patchState({
      isMenuBarVisible: !inView && scrollY > 0
    });
  }, [inView]);
  var PLATFORM_LOGIN_ITEM = {
    id: 'platform-login',
    name: loginLabel,
    url: platformUrl,
    children: [],
    isDisclosed: false,
    __icon: React.createElement(PersonCircleIcon, null),
    __iconSize: 32,
    isActive: false
  }; // TODO - make this recursive

  var pinnedNavigationMenuItems = map(__spreadArray([], __read(menu && menu.items || []), false), function (item) {
    var _a;

    var hasChildren = item.children && !!item.children.length;
    var isActive = hasChildren ? includes((_a = item.children) === null || _a === void 0 ? void 0 : _a.map(function (item) {
      return item.path;
    }), currentEntity && currentEntity.path) : trim(item.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(item.path, '/');
    return __assign(__assign({}, item), {
      isDisclosed: disclosedMenuItem === item.id,
      hasChildren: hasChildren,
      children: map(item.children, function (child) {
        return __assign(__assign({}, child), {
          isDisclosed: false,
          children: [],
          hasChildren: false,
          isActive: trim(item.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(item.path, '/')
        });
      }),
      isActive: isActive
    });
  });

  var navigationMenuItems = __spreadArray([], __read(pinnedNavigationMenuItems), false);

  var _k = site.headerButtons,
      headerButtons = _k === void 0 ? [] : _k;

  try {
    for (var headerButtons_1 = __values(headerButtons), headerButtons_1_1 = headerButtons_1.next(); !headerButtons_1_1.done; headerButtons_1_1 = headerButtons_1.next()) {
      var link = headerButtons_1_1.value;
      /* @ts-ignore */

      var Icon = icons[(_b = link.icon) === null || _b === void 0 ? void 0 : _b.component];
      navigationMenuItems.push({
        id: link.id,
        name: link.label || ((_c = link.page) === null || _c === void 0 ? void 0 : _c.title) || ((_d = link.page) === null || _d === void 0 ? void 0 : _d.name) || link.name,
        url: link.url || ((_e = link.page) === null || _e === void 0 ? void 0 : _e.path),
        isDisclosed: false,
        page: link.page,
        __icon: Icon && React.createElement(Icon, null),
        // TODO make these work
        isActive: trim(link.path) !== '' && trim(currentEntity && currentEntity.path, '/') === trim(link.path, '/'),
        hasChildren: false,
        children: []
      });
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (headerButtons_1_1 && !headerButtons_1_1.done && (_a = headerButtons_1.return)) _a.call(headerButtons_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  if (loginLabel) {
    navigationMenuItems.push(PLATFORM_LOGIN_ITEM);
  }

  var menuItemLinkColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    sub: 'menu-item-link',
    fallbacks: [color, 'dark'],
    invertedFallbacks: [color, 'light']
  });
  var menuItemLinkActiveColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: activeColor,
    sub: 'menu-item-link-active',
    fallbacks: ['link-active', 'link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link-active', 'mid-brand', 'primary', 'light']
  });
  var textColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    sub: 'menu-button-text',
    fallbacks: ['light'],
    invertedFallbacks: ['dark-brand', 'primary']
  });
  var menuItemLinkHoverColor = useComponentColor({
    cls: cls,
    isInverted: isInverted,
    prop: hoverColor,
    sub: 'menu-item-link-hover',
    fallbacks: ['link-hover', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link-hover', 'mid-brand', 'primary']
  });
  var menuItemLinkInvertedColor = useComponentColor({
    cls: cls,
    isInverted: true,
    sub: 'menu-item-link',
    fallbacks: [color, 'dark'],
    invertedFallbacks: ['light']
  });
  var menuItemLinkInvertedActiveColor = useComponentColor({
    cls: cls,
    isInverted: true,
    prop: activeColor,
    sub: 'menu-item-link-active',
    fallbacks: ['link-active', 'link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link-active', 'mid-brand', 'primary', 'light']
  });
  var menuItemLinkInvertedHoverColor = useComponentColor({
    cls: cls,
    isInverted: true,
    prop: hoverColor,
    sub: 'menu-item-link-hover',
    fallbacks: ['link-hover', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-link-hover', 'mid-brand', 'primary']
  });
  var menuItemChildLinkInvertedActiveColor = useComponentColor({
    cls: cls,
    isInverted: true,
    prop: activeColor,
    sub: 'menu-item-child-link-active',
    fallbacks: ['child-link-active', 'link', 'mid-brand', 'primary'],
    invertedFallbacks: ['inverted-child-link-active', 'mid-brand', 'primary', 'light']
  });
  var menuItemChildLinkActiveColor = menuItemLinkColor;
  var menuItemChildLinkHoverColor = menuItemLinkHoverColor;
  var menuButtonColor = menuItemLinkColor;
  var menuButtonHoverColor = menuItemLinkHoverColor;
  return __assign(__assign({}, context), {
    component: component || SiteHeaderLayout,
    variant: variant,
    showLogin: showLogin,
    showSearch: showSearch,
    showShare: showShare,
    showContactUs: showContactUs,
    disclosedMenuItem: disclosedMenuItem,
    isLangMenuVisible: isLangMenuVisible,
    isShareMenuVisible: isShareMenuVisible,
    isNavigationMenuVisible: isNavigationMenuVisible,
    isPinnedNavigationMenuVisible: isPinnedNavigationMenuVisible,
    isContactUsMenuVisible: isContactUsMenuVisible,
    isMenuBarVisible: isMenuBarVisible,
    isInverted: isInverted,
    backgroundColor: backgroundColor,
    color: color,
    ref: ref,
    langMenuRef: langMenuRef,
    langMenuRevealRef: langMenuRevealRef,
    shareMenuRef: shareMenuRef,
    shareMenuRevealRef: shareMenuRevealRef,
    navigationMenuRef: navigationMenuRef,
    pinnedNavigationMenuRef: pinnedNavigationMenuRef,
    navigationDisclosedItemRef: navigationDisclosedItemRef,
    onShareButtonClick: function onShareButtonClick(e) {
      e.stopPropagation();
      toggleShareMenu();
    },
    onLangButtonClick: function onLangButtonClick(e) {
      e.stopPropagation();
      toggleLangMenu();
    },
    onMenuButtonClick: function onMenuButtonClick(e) {
      e.stopPropagation();
      toggleNavigationMenu();
    },
    onPinnedMenuButtonClick: function onPinnedMenuButtonClick(e) {
      e.stopPropagation();
      togglePinnedNavigationMenu();
    },
    onContactUsButtonClick: function onContactUsButtonClick(e) {
      e.stopPropagation();
      toggleContactUsMenu();
    },
    navigationMenuItems: navigationMenuItems,
    pinnedNavigationMenuItems: pinnedNavigationMenuItems,
    loginLabel: loginLabel,
    toggleLangMenu: toggleLangMenu,
    toggleShareMenu: toggleShareMenu,
    toggleNavigationMenu: toggleNavigationMenu,
    togglePinnedNavigationMenu: togglePinnedNavigationMenu,
    toggleContactUsMenu: toggleContactUsMenu,
    setDisclosedMenuItem: setDisclosedMenuItem,
    hideDisclosedMenuItem: hideDisclosedMenuItem,
    hideLangMenu: hideLangMenu,
    hideShareMenu: hideShareMenu,
    hideNavigationMenu: hideNavigationMenu,
    hidePinnedNavigationMenu: hidePinnedNavigationMenu,
    hideContactUsMenu: hideContactUsMenu,
    showLangMenu: showLangMenu,
    showShareMenu: showShareMenu,
    showNavigationMenu: showNavigationMenu,
    showPinnedNavigationMenu: showPinnedNavigationMenu,
    showContactUsMenu: showContactUsMenu,
    isDisclosedMenuItem: function isDisclosedMenuItem(item) {
      var _a;

      return !!((_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.length) && disclosedMenuItem === (item === null || item === void 0 ? void 0 : item.id);
    },
    textColor: textColor,
    menuItemLinkColor: menuItemLinkColor,
    menuItemLinkActiveColor: menuItemLinkActiveColor,
    menuItemLinkHoverColor: menuItemLinkHoverColor,
    menuItemLinkInvertedColor: menuItemLinkInvertedColor,
    menuItemLinkInvertedActiveColor: menuItemLinkInvertedActiveColor,
    menuItemLinkInvertedHoverColor: menuItemLinkInvertedHoverColor,
    menuItemChildLinkInvertedActiveColor: menuItemChildLinkInvertedActiveColor,
    menuItemChildLinkActiveColor: menuItemChildLinkActiveColor,
    menuItemChildLinkHoverColor: menuItemChildLinkHoverColor,
    menuButtonColor: menuButtonColor,
    menuButtonHoverColor: menuButtonHoverColor
  });
};